import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AuthRedirectService {
	private redirectUrl: string | null = null;

	setRedirectUrl(url: string | null): void {
		if (!url) {
			return;
		}
		if (this.isAuthRoute(url)) {
			return;
		}
		this.redirectUrl = url;
	}

	consumeRedirectUrl(): string | null {
		const url = this.redirectUrl;
		this.redirectUrl = null;
		return url;
	}

	clearRedirectUrl(): void {
		this.redirectUrl = null;
	}

	isAuthRoute(url: string): boolean {
		const path = url.split('?')[0];
		return ['/login', '/sign-up', '/signin', '/register', '/sign-in'].some((route) => path.startsWith(route));
	}
}

